import { AstroTransitionLink } from "@components/ui/AstroTransitionLink"
import { useRoutePageContext } from "@components/ui/route-page-context"

type BackButtonProps = {
  backPage?: string
}

export function BackButton({ backPage }: BackButtonProps) {
  const { locale, currentPage } = useRoutePageContext()
  const destination = `/${locale}/${backPage || currentPage}`

  return (
    <AstroTransitionLink
      to={destination}
      data-testid="back-button"
      className="mx-auto inline-block bg-[var(--deep-blue)] px-[1em] py-[0.5em] text-[1.6em]"
    >
      <i className="fa-sharp fa-regular fa-arrow-left" />
    </AstroTransitionLink>
  )
}

export default BackButton
